import React from "react";

/** Vangt een onverwachte fout op zodat het scherm niet wit blijft. */
export default class ErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("CampAd Pro:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted/40 p-6" data-testid="error-boundary">
        <div className="max-w-md text-center space-y-4">
          <p className="font-display font-extrabold text-2xl text-foreground">Er ging even iets mis</p>
          <p className="text-sm text-muted-foreground">
            Uw gegevens zijn bewaard. Herlaad de pagina om verder te werken.
          </p>
          <button onClick={() => window.location.reload()} data-testid="error-reload"
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90 transition-opacity">
            Pagina herladen
          </button>
        </div>
      </div>
    );
  }
}
